import type { CityConfig } from "../city-template/types";

export const matthewsConfig: CityConfig = {
  city: "Matthews",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "matthews",
  route: "/matthews",
  title: "Emergency Passport Matthews, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Matthews, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Mecklenburg County and southeast Charlotte. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Matthews, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Matthews and southeast Charlotte travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Matthews%20North%20Carolina%20charming%20downtown%20main%20street%20at%20golden%20hour%20with%20historic%20buildings%20and%20tree-lined%20sidewalks%2C%20small%20town%20American%20atmosphere%20with%20modern%20suburban%20growth%2C%20warm%20sunset%20light%20over%20Mecklenburg%20County%2C%20green%20trees%20and%20well-maintained%20storefronts%2C%20vintage%20train%20station%20and%20community%20park%20visible%2C%20professional%20cityscape%20photography%20with%20warm%20earthy%20tones%20and%20southern%20community%20charm%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=matthews-hero-nc-001&orientation=landscape",
  heroImageAlt: "Matthews North Carolina charming downtown historic district with tree-lined main street and warm sunset light",
  geoPosition: "35.1168;-80.7237",
  geoPlacename: "Matthews, North Carolina",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 240 miles from Matthews via I-85",
  },
  nearbyCitiesZips: [
    { name: "Matthews", zips: "28104, 28105" },
    { name: "Charlotte", zips: "28201–28299" },
    { name: "Mint Hill", zips: "28227" },
    { name: "Indian Trail", zips: "28079" },
    { name: "Stallings", zips: "28104" },
    { name: "Monroe", zips: "28110, 28111, 28112" },
    { name: "Wesley Chapel", zips: "28104" },
    { name: "Waxhaw", zips: "28173" },
    { name: "Weddington", zips: "28104" },
    { name: "Pineville", zips: "28134" },
    { name: "Huntersville", zips: "28070, 28078" },
    { name: "Cornelius", zips: "28031" },
    { name: "Davidson", zips: "28035, 28036" },
    { name: "Concord", zips: "28025, 28026, 28027" },
    { name: "Kannapolis", zips: "28081, 28082, 28083" },
    { name: "Gastonia", zips: "28052, 28054, 28056" },
    { name: "Harrisburg", zips: "28075" },
    { name: "Raleigh", zips: "27601–27699" },
    { name: "Durham", zips: "27701–27717" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Mecklenburg County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Southeast Charlotte Hub", desc: "Serving Matthews, Mint Hill, Indian Trail, and the Union County corridor" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/charlotte" },
    { name: "Fast passport renewal in Huntersville, NC", route: "/huntersville" },
    { name: "Emergency passport help in Concord, NC", route: "/concord-nc" },
    { name: "Urgent passport services in Kannapolis, NC", route: "/kannapolis" },
    { name: "Same-day passport help in Gastonia, NC", route: "/gastonia" },
    { name: "Passport courier services in Raleigh, NC", route: "/raleigh" },
    { name: "Expedited passport services in Indian Trail, NC", route: "/indian-trail" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Matthews remotely via secure courier. We do not have a walk-in office in Matthews — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Mecklenburg County and the southeast Charlotte area travelers.",
  fpcOfficeAddress: "301 S McDowell St, Charlotte, North Carolina 28204",
  fpcOfficeDistance: "Serving all of Mecklenburg County and the southeast Charlotte metropolitan region",
  serviceAreaIntro: "From the charming downtown streets of Matthews to the suburban neighborhoods of Mint Hill, from the growing communities of Indian Trail and Stallings to the bustling corridors of southeast Charlotte, from the quiet roads of Waxhaw and Weddington to the historic town of Monroe — Fast Passport Center serves the entire Matthews region. We regularly help travelers from Union County, Mecklenburg County, and the southeast Charlotte area get their passports fast.",
  nearbyCitiesIntro: "We serve all Matthews neighborhoods and the surrounding southeast Charlotte area including Charlotte, Mint Hill, Indian Trail, Stallings, Monroe, Wesley Chapel, Waxhaw, Weddington, Pineville, Huntersville, Cornelius, Davidson, Concord, Kannapolis, Gastonia, and Harrisburg. If you are anywhere in Mecklenburg County, Union County, or the southeast Charlotte metropolitan area, we have you covered.",
  howItWorksIntro: "Most Matthews travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Matthews travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Matthews and southeast Charlotte travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Matthews? Here are the most common ones we hear from Mecklenburg County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Matthews international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Michelle L.",
      location: "Matthews, NC",
      rating: 5,
      text: "My passport expired 4 days before our family trip to the Bahamas. Fast Passport Center had my renewal ready in 28 hours. I never left Matthews. The dedicated agent was incredible.",
      service: "Passport Renewal",
    },
    {
      name: "Daniel P.",
      location: "Mint Hill, NC",
      rating: 5,
      text: "Emergency passport for a family emergency in Italy. Got it in 25 hours. Fast Passport Center handled everything — I didn't have to drive to Atlanta. Truly a lifesaver.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa G.",
      location: "Indian Trail, NC",
      rating: 5,
      text: "First passport for my 9-year-old before our Disney cruise. Fast Passport Center walked us through every document and had her passport in 5 days. The process was seamless.",
      service: "Child Passport",
    },
    {
      name: "Gregory W.",
      location: "Waxhaw, NC",
      rating: 5,
      text: "Lost my passport 2 days before a business trip to Germany. Fast Passport Center had a replacement in my hands in 32 hours. Their southeast Charlotte coverage is outstanding.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "matthews-1",
      name: "Matthews Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 W John St",
      city: "Matthews",
      state: "NC",
      zip: "28105",
      phone: "(704) 847-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Matthews",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Matthews facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "matthews-2",
      name: "Mint Hill Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7815 Matthews Mint Hill Rd",
      city: "Mint Hill",
      state: "NC",
      zip: "28227",
      phone: "(704) 545-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles west of Matthews",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Mint Hill and eastern Mecklenburg County. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "matthews-3",
      name: "Indian Trail Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6401 Indian Trail Fairview Rd",
      city: "Indian Trail",
      state: "NC",
      zip: "28079",
      phone: "(704) 821-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles east of Matthews",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Union County and Indian Trail area. Less crowded than Charlotte. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "matthews-4",
      name: "Monroe Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1201 W Roosevelt Blvd",
      city: "Monroe",
      state: "NC",
      zip: "28110",
      phone: "(704) 289-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles southeast of Matthews",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Union County and Monroe area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "matthews-5",
      name: "Mecklenburg County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "832 E 4th St",
      city: "Charlotte",
      state: "NC",
      zip: "28202",
      phone: "(704) 686-0400",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "12 miles west of Matthews, Courthouse",
      website: "https://www.mecknc.gov/",
      websiteLabel: "Mecklenburg County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "matthews-6",
      name: "Charlotte Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Tryon St",
      city: "Charlotte",
      state: "NC",
      zip: "28202",
      phone: "(704) 344-4183",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles west of Matthews",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Charlotte metro. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Matthews photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Mecklenburg County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Matthews applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Mecklenburg County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Matthews travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Matthews." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Matthews address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Matthews before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Matthews for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Matthews?", a: "Fast Passport Center offers fast passport renewal in Matthews in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Matthews?", a: "The nearest regional passport agency to Matthews is the Atlanta Passport Agency, approximately 240 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Matthews without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Matthews?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 4 hours from Matthews — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Mecklenburg County and Union County residents." },
    { q: "Do you serve the entire southeast Charlotte area?", a: "Absolutely. Fast Passport Center serves the entire southeast Charlotte metropolitan area including Matthews, Charlotte, Mint Hill, Indian Trail, Stallings, Monroe, Wesley Chapel, Waxhaw, Weddington, Pineville, Huntersville, Cornelius, Davidson, Concord, Kannapolis, Gastonia, and Harrisburg. Our courier service works seamlessly from any address in Mecklenburg County, Union County, and surrounding areas." },
    { q: "Can I expedite a child passport in Matthews?", a: "Yes. Fast Passport Center expedites child passports in Matthews for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Mecklenburg County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Matthews with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Matthews", address: "1409 Matthews Township Pkwy, Matthews, NC 28105", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Matthews", address: "1910 S Independence Blvd, Matthews, NC 28105", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Matthews", address: "1130 E Independence Blvd, Matthews, NC 28105", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Mint Hill", address: "6820 Matthews Mint Hill Rd, Mint Hill, NC 28227", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Indian Trail", address: "6500 Indian Trail Fairview Rd, Indian Trail, NC 28079", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Monroe", address: "1409 W Roosevelt Blvd, Monroe, NC 28110", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Waxhaw", address: "1309 Waxhaw Pkwy, Waxhaw, NC 28173", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Charlotte", address: "550 S Tryon St, Charlotte, NC 28202", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Matthews",
      address: "1510 N Independence Blvd, Matthews, NC 28105",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Charlotte East",
      address: "8501 East Independence Blvd, Charlotte, NC 28227",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Monroe",
      address: "1821 Windsor Square Dr, Monroe, NC 28110",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Union County and Monroe area. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Charlotte South",
      address: "201 W Arrowood Rd, Charlotte, NC 28217",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Charlotte metro and south Mecklenburg area. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "12 miles west of Matthews",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international airport for the Charlotte metro area. American Airlines hub with direct flights to Europe, Mexico, the Caribbean, and major domestic destinations. Only 20 minutes from Matthews.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "80 miles northeast of Matthews",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for North Carolina residents. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "160 miles east of Matthews",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { name: "NCDHHS Vital Records", url: "https://vitalrecords.nc.gov/", description: "North Carolina birth, death, marriage, and divorce certificates" },
    { name: "Mecklenburg County Register of Deeds", url: "https://www.mecknc.gov/rod/", description: "Birth, death, and marriage records for Mecklenburg County" },
    { name: "Mecklenburg County Superior Court", url: "https://www.nccourts.gov/locations/mecklenburg-county", description: "Divorce records and court documents for Mecklenburg County" },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
};